import { Check } from "lucide-react";
import { useEffect, useRef } from "react";

export const SuccessState = ({
  subtitle,
  title,
}: {
  subtitle: string;
  title: string;
}) => {
  const headingRef = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    headingRef.current?.focus();
  }, []);

  return (
    <div aria-live="polite" className="flex flex-col gap-6">
      <div
        aria-hidden
        className="flex size-14 items-center justify-center rounded-full bg-coral-50 text-coral-700"
      >
        <Check size={26} strokeWidth={2} />
      </div>
      <div className="flex flex-col gap-2">
        <h1
          className="font-semibold text-[32px] leading-[1.1] tracking-[-0.02em] outline-none"
          ref={headingRef}
          tabIndex={-1}
        >
          {title}
        </h1>
        <p className="text-base text-n-600 leading-[1.55]">{subtitle}</p>
      </div>
    </div>
  );
};
